import { render } from "./Backlogs.vue?vue&type=template&id=fb4dbf76"
import script from "./Backlogs.vue?vue&type=script&lang=js"
export * from "./Backlogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__